<script>
export default {
  name: 'App',
};
</script>

<template>
  <router-view />
</template>
